import { ColumnId } from './TransactionsList.types';

export const itemsPerPage = 10;

export const defaultSortState = {
    [ColumnId.Wallet]: undefined,
    [ColumnId.CreatedDate]: undefined,
    [ColumnId.Type]: undefined,
    [ColumnId.Amount]: undefined,
    [ColumnId.Status]: undefined,
};
